import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import { useReveal } from '../../../components/landingPage/common/landingHooks';
import AeoResourcesSection from '../../../components/landingPage/AeoArticles/AeoResourcesSection';
import useDocumentHead from '../../../components/landingPage/AeoArticles/useDocumentHead';
import hubWebPageSchema from '../../../components/landingPage/AeoArticles/aeoHubSchema';

// Accelerator ICP hub page — anchor for the /accelerator/* AEO article cluster.
const LandingHomeAccelerator = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useDocumentHead({
        title: 'Diligentsia for Accelerators — Investment-Ready Cohorts',
        description: 'Diligentsia helps accelerators get every cohort company investment-ready: certified Diligence Packs, AI-assisted document analysis, and consistent cohort reporting.',
        canonicalPath: '/accelerator/',
        schema: hubWebPageSchema('accelerator'),
    });

    return (
        <div className="lp-page" ref={rootRef}>
            <section className="lp-hero">
                <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
                <div className="lp-hero-inner">
                    <div className="lp-hero-copy">
                        <h1 className="lp-h1" data-lp-reveal>Every cohort company,<br />investment-ready.</h1>
                        <p className="lp-lead" data-lp-reveal data-lp-delay="80">
                            Diligentsia gives accelerators a consistent, certified way to get portfolio companies diligence-ready —
                            AI-assisted Diligence Packs, structured progress reporting across the cohort, and a standard investors recognise.
                        </p>
                        <div className="lp-cta-row" data-lp-reveal data-lp-delay="160">
                            <Link className="lp-btn lp-btn--primary" to={ROUTES.REGISTER}>Get started free</Link>
                            <Link className="lp-btn lp-btn--ghost" to={ROUTES.BLOGS}>Explore resources</Link>
                        </div>
                    </div>
                </div>
            </section>
            <AeoResourcesSection icpSlug="accelerator" heading="Accelerator resources" />
        </div>
    );
};

export default LandingHomeAccelerator;
